import ToolTipComponent from "@CubeComponents/html/tooltip";
import React from "react";
import type { TranslatedString } from "@i18n";

type DisabledTooltipProps = {
  disabled: boolean;
  tooltip: TranslatedString;
  children: React.ReactElement<unknown>;
  position?: "top" | "bottom" | "left" | "right";
};

export const DisabledTooltip = ({ disabled, tooltip, children, position = "bottom" }: DisabledTooltipProps) => {
  // If not disabled, return as-is (no wrapper, no tooltip)
  if (!disabled) {
    return children;
  }

  return (
    <ToolTipComponent showTipPointer={false} position={position} content={tooltip}>
      {/* span is required because disabled elements don't fire hover */}
      <span className="inline-block cursor-not-allowed">{children}</span>
    </ToolTipComponent>
  );
};
